import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

const A = ({ node, href = "", children, ...props }) =>
  href.startsWith("/") ? (
    <Link to={href} className="font-semibold underline underline-offset-4">{children}</Link>
  ) : (
    <a {...props} href={href} target="_blank" rel="noopener noreferrer" className="font-semibold underline underline-offset-4">{children}</a>
  );

const components = { p: ({ children }) => <span className="block">{children}</span>, a: A };

// Inline-safe text renderer for CMS copy: keeps line breaks, supports **bold**, *italic* and [links](url).
export const Rich = ({ text, className = "", testId }) => (
  <span className={`block whitespace-pre-line ${className}`} data-testid={testId}>
    <ReactMarkdown components={components} skipHtml allowedElements={["p", "a", "strong", "em", "br"]} unwrapDisallowed>{text || ""}</ReactMarkdown>
  </span>
);
